import {api} from '../../api';
import {createMutation} from '../../lib';

const {putFiltersSets} = api.filtersSets;

export const usePutFiltersSets = createMutation((params: Parameters<typeof putFiltersSets>) =>
  putFiltersSets(...params),
);
